<template>
    <div class="mb-8 d-flex flex-column" :class="containerClasses">
        <v-img contain :class="imageClasses" max-width="100%" :src="layout.file"> </v-img>
        <div>
            {{ layout.label }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        layout: {
            type: Object,
            required: true,
        },

        classes: {
            type: Object,
            default: () => {},
        },

        contentClass: String,
    },

    computed: {
        containerClasses() {
            return {
                'align-start': this.layout.alignment === 'left',
                'align-center': this.layout.alignment === 'center',
                'align-end': this.layout.alignment === 'right',
            };
        },
        imageClasses() {
            return {
                'image-block-size-small': this.layout.size === 'small',
                'image-block-size-medium': this.layout.size === 'medium',
                'image-block-size-large': this.layout.size === 'large',
            };
        },
    },
};
</script>

<style scoped>
.image-block-size-small {
    width: 40%;
}

.image-block-size-medium {
    width: 70%;
}

.image-block-size-large {
    width: 100%;
}
</style>
